import ClearIcon from '@mui/icons-material/Clear';
import { IconButton } from '@mui/material';
import { IMediaFile, PostType } from 'interfaces/Backstage.interface';
import { FC, Fragment } from 'react';
import { backButtonStyles, editButtonStyles, Image, VideoCont } from './styled';

interface IMultiMediaEdit {
  mediaFiles: IMediaFile[] | [];
  handleEditMode: () => void;
  editingMode: boolean;
  handleFilterMedia: (url: string) => void;
}
const MultiMediaEdit: FC<IMultiMediaEdit> = ({
  mediaFiles,
  handleEditMode,
  editingMode,
  handleFilterMedia,
}) => {
  return (
    <div
      style={{
        position: 'relative',
      }}
    >
      <IconButton
        onClick={() => {
          handleEditMode();
        }}
        style={backButtonStyles}
      >
        Go Back
      </IconButton>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
        {mediaFiles.map((media, index) => (
          <Fragment key={index}>
            {media.type === PostType.IMAGE ? (
              <div style={{ position: 'relative' }}>
                <Image
                  key={media.url}
                  src={media.url}
                  loading="lazy"
                  height={'100%'}
                  width={'100%'}
                />
                <IconButton
                  sx={{ width: '20px', height: '20px' }}
                  onClick={() => {
                    handleFilterMedia(media.url);
                  }}
                  style={editButtonStyles}
                >
                  <ClearIcon />
                </IconButton>
              </div>
            ) : media.type === PostType.VIDEO ? (
              <div style={{ position: 'relative' }}>
                <VideoCont>
                  <video
                    key={media.url}
                    src={media.url}
                    controls
                    style={{ width: '100%' }}
                  />
                </VideoCont>
                <IconButton
                  sx={{ width: '20px', height: '20px' }}
                  onClick={() => {
                    handleFilterMedia(media.url);
                  }}
                  style={editButtonStyles}
                >
                  <ClearIcon />
                </IconButton>
              </div>
            ) : (
              <></>
            )}
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default MultiMediaEdit;
